//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable vue/no-mutating-props */
import Field from '../field';
import Menu from '../menu/index.vue';
import x24icarrowdown from '../../../../iconsPublicSite/icons/x24icarrowdown/x24icarrowdown';

import VirtualScroll from '../virtual-scroll/index.vue';
import CommonSelect from '../../../../components/commonSelect';
import ScrollArea from '../scrollArea';

import SelectOption from './SelectOption.vue';

export default ({
  components: { Field, Menu, x24icarrowdown, SelectOption, VirtualScroll, ScrollArea },
  extends: CommonSelect,
});
